import React, { useEffect, useState } from 'react'
import PageTitle from '../../Utility/PageTitle'
import { Avatar, Button, Card, Tag, message } from 'antd'
import { useFetch } from '../../../services/ApiService';
import ImageUploader from '../../Utility/ImageUploader';

function Profile() {

  const [loading, setLoading] = useState(false);
  const [data, setData] = useState([]);
  const { fetchApi } = useFetch();
  const [profileImage, setProfileImage] = useState(0);
  const [uploadBtnLoading, setUploadBtnLoading] = useState(false);

  const getAgencyData = async () => {
    setLoading(true);
    await fetchApi('/api/agency', 'GET', {}).then(res => {
      if (res.length > 0) {
        setData(res[0]);
      }
    }).catch(err => {
      console.log(err);
    })
    setLoading(false);
  }



  const getInitials = (value) => {
    const splitValue = value.split(' ');
    const initials = splitValue.reduce((item, curItem) => {
      return item[0] + curItem[0]
    });
    return initials
  }

  const handleProfileImageUpload = async (id) => {

    setUploadBtnLoading(true);
    const payload = {
      attachment_url_id: +profileImage
    };
    await fetchApi(`/api/agency/${id}`, 'PATCH', payload).then(res => {
      message.success("Profile Pic Uploaded Successfully");
      setProfileImage(0);
      getAgencyData();
    }).catch(err => {
      console.log(err);
    })
    setUploadBtnLoading(false);
  }

  useEffect(() => {
    getAgencyData();
  }, [])


  return (
    <>
      <PageTitle title="My Profile" />
      <div className='row'>
        <div className='col-xxl-8 offset-xxl-2'>
          <Card
            loading={loading}

          >
            {
              Object.keys(data).length > 0 &&
              <div className='candidate-view'>
                <div className='candidate-view-info justify-content-between'>
                  <div className='candidate-view-label'><div className='avatar-user'>

                    {
                      data.attachment_url === "" ?
                        <Avatar size={64}>{getInitials(data?.agency_name)}</Avatar>
                        :
                        <Avatar size={64} src={data?.attachment_url} />
                    }
                    <div className='avatar-user-info'>
                      <h5>{data?.agency_name}</h5>

                    </div>
                  </div></div>

                  <div className='d-flex align-items-center'>
                    <ImageUploader setImageId={setProfileImage} uploadText="+ Upload Profile Picture" />
                    {profileImage !== 0 && <Button loading={uploadBtnLoading} onClick={() =>handleProfileImageUpload(data?.id)}>Save</Button>}
                  </div>

                </div>
                <div className='candidate-view-info'>
                  <div className='candidate-view-label'>Agency Name</div>
                  <div className='candidate-view-value'>{data?.agency_name}</div>
                </div>


                <div className='candidate-view-info'>
                  <div className='candidate-view-label'>Agency ID</div>
                  <div className='candidate-view-value'>{data?.id}</div>
                </div>

                <div className='candidate-view-info'>
                  <div className='candidate-view-label'>Phone No.</div>
                  <div className='candidate-view-value'>{data?.country_code} {data?.mobile}</div>
                </div>
                <div className='candidate-view-info'>
                  <div className='candidate-view-label'>Email</div>
                  <div className='candidate-view-value'>{data?.email}</div>
                </div>


                <div className='candidate-view-info'>
                  <div className='candidate-view-label'>Address</div>
                  <div className='candidate-view-value'>{data?.address}</div>
                </div>
                <div className='candidate-view-info'>
                  <div className='candidate-view-label'>Status</div>
                  <div className='candidate-view-value'>{data?.status ? <Tag color='green'>Active</Tag> : <Tag color='red'>Inactive</Tag>}</div>
                </div>
              </div>
            }


          </Card>

        </div>
      </div>
    </>
  )
}

export default Profile
